<template>
  <div>
    <v-card style="width: 320px;">
      <v-card-title class="justify-center">
        <v-img :src="$root.cdn + 'logo.png'" max-width="180" class="mx-auto mb-1" />
        Reset Password
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="pass1"
          label="New Password"
          outlined
          hide-details
          class="mb-2"
          type="password"
          :disabled="resetting"
        />
        <v-text-field
          v-model="pass2"
          label="Confirm Password"
          outlined
          hide-details
          class="mb-2"
          type="password"
          :disabled="resetting"
          @keydown="checkKeypress"
        />
        <div class="text-center mt-4">
          <v-btn color="primary" :loading="resetting" @click="requestChange" :disabled="!pass1 || !pass2">Change</v-btn>
        </div>
        <div class="text-center mt-4">
          <router-link :to="{name: 'auth'}" style="text-decoration: none;">Back To Login</router-link>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'AuthReset',
  data: () => ({
    pass1: null,
    pass2: null,
    resetting: false
  }),
  computed: {
    token () {
      return this.$route.params.token
    }
  },
  methods: {
    requestChange() {
      if(this.pass1 !== this.pass2) {
        this.$swal.fire('Passwords Must Match','','error')
        return
      }

      this.resetting = true
      let params = {
        token:            this.token,
        password:         this.pass1,
        password_confirm: this.pass2
      }

      this.$http.post('auth/reset-password', params)
        .then(response => {
          this.$router.push({name: 'auth', query: { e: response.data.email }})
          this.$swal.fire({
            title: 'Updated', 
            html: 'Your password has been updated. Please log in to continue.', 
            icon: 'success'
          }).then(() => {
            document.getElementById('pwordField').focus()
          })
        })
        .catch(() => {
          this.$swal.fire('Error', 'There was an error submitting your request. Please try again.', 'error')
          this.resetting = false
        })
    },
    checkKeypress(e) {
      if(e.key == 'Enter') this.requestChange()
    }
  }
}
</script>